import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { images } from '../assets';
import SwipeableMenu from './SwipeableMenu';
import Navbar from './home/Navbar';
import HeroSection from './home/HeroSection';
import RedSocialSection from './home/RedSocialSection';
import ExerciseGrid from './home/ExerciseGrid';
// AboutSection content is now integrated into ScrollCinematicExperience
// import AboutSection from './home/AboutSection';
import TarifaSection from './home/TarifaSection';
import ScrollTransitionGridContainer from './home/ScrollTransitionGridContainer';
import AngledCurtainRevealTransition from './home/AngledCurtainRevealTransition';
import FaqSection from './home/FaqSection';
import Footer from './home/Footer';

const HomePage = ({ typewriterText, loopNum, toRotate }) => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [shouldOpenAccordions, setShouldOpenAccordions] = useState(false);

  // Scroll automático a ejercicios cuando se navega con el state
  useEffect(() => {
    if (location.state?.scrollToExercises) {
      setShouldOpenAccordions(true);
      setTimeout(() => {
        const ejerciciosSection = document.getElementById('ejercicios');
        if (ejerciciosSection) {
          ejerciciosSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, [location]);


  const navLinks = [
    { href: '#', text: 'INICIO' },
    { href: '#about', text: 'NOSOTROS' },
    { href: '#tarifas', text: 'HORARIOS' },
    { href: '#resultados', text: 'RESULTADOS' },
    { href: '#faq', text: 'FAQ' },
    { href: '#contacto', text: 'CONTACTOS' },
  ];

  const socialLinks = [
    { href: 'https://www.tiktok.com/@energyhco', icon: images.tik_tok, name: 'TikTok' },
    { href: 'https://www.facebook.com/energy.huanuco', icon: images.facebook, name: 'Facebook' },
    { href: 'https://www.instagram.com/energyhuanuco/', icon: images.instagram, name: 'Instagram' },
  ];

  return (
    <>
      <SwipeableMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)}>
        <ul className="flex flex-col space-y-8 text-center mt-24">
          {navLinks.map(link => (
            <li key={link.href}>
              <a
                href={link.href}
                onClick={() => setIsMenuOpen(false)}
                className="bebas-font text-2xl text-white hover:text-gray-900 tracking-widest transition-colors"
              >
                {link.text}
              </a>
            </li>
          ))}

        </ul>
        <div className="border-t border-gray-700 mt-auto pt-6">
          <div className="flex justify-center space-x-6">
            {socialLinks.map(social => (
              <a href={social.href} key={social.name} target="_blank" rel="noreferrer" className="group flex flex-col items-center space-y-2">
                <img src={social.icon} alt={social.name} className="h-8 w-8 transition-transform group-hover:scale-110" />
                <span
                  className="text-xs tracking-wider bg-clip-text text-gray-500 group-hover:animate-shine group-hover:text-gray-400"
                  style={{
                    backgroundImage: 'linear-gradient(120deg, rgba(255, 255, 255, 0) 30%, rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 0) 70%)',
                    backgroundSize: '200% 100%',
                    WebkitBackgroundClip: 'text',
                  }}
                >
                  {social.name}
                </span>
              </a>
            ))}
          </div>
        </div>
      </SwipeableMenu>

      {/* Botón de menú móvil */}
      <button
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        className="md:hidden fixed top-5 right-5 z-[100] flex items-center gap-2 text-white bg-black/60 backdrop-blur-md px-3.5 py-1.5 rounded-full border border-white/10 hover:border-white/30 transition-all duration-300 shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        aria-label={isMenuOpen ? "Cerrar menú de navegación" : "Abrir menú de navegación"}
        aria-expanded={isMenuOpen}
      >
        <span className="bebas-font text-lg tracking-wider">
          {isMenuOpen ? 'CERRAR' : 'MENU'}
        </span>
        <div className={`menu-icon-container ${isMenuOpen ? 'open' : ''}`}>
          <div className="menu-icon-bar bar1 bg-white"></div>
          <div className="menu-icon-bar bar2 bg-white"></div>
        </div>
      </button>

      {/* Navbar */}
      <Navbar />

      <main>
        {/* Hero Section */}
        <HeroSection
          typewriterText={typewriterText}
          loopNum={loopNum}
          toRotate={toRotate}
        />

        {/* About Section — content integrated into the cinematic scroll experience above */}

        {/* Contenedor de Malla con transición de fondo (Tarifas) */}
        <ScrollTransitionGridContainer>
          <TarifaSection />
        </ScrollTransitionGridContainer>

        {/* Transición de máscara angular: Resultados -> Nutrición */}
        <AngledCurtainRevealTransition />

        {/* Red Social Section */}
        <RedSocialSection />

        {/* Separador de línea con gradiente */}
        <div className="px-4 md:px-8 bg-[#0a0a0a]">
          <div className="h-px w-full bg-gradient-to-r from-transparent via-blue-500/20 to-transparent"></div>
        </div>

        {/* Exercise Grid */}
        <ExerciseGrid shouldOpenAccordions={shouldOpenAccordions} />

        {/* FAQ Section */}
        <FaqSection />
      </main>

      {/* Footer (Contactos) */}
      <Footer />
    </>
  );
};

export default HomePage;
